import http from '@/http'

export type StationMode = 'checkin' | 'lead' | 'brinde'

export type PaginationArg = {
  page: number,
  limit: number,
}

export type FilterArg = {
  search?: string | null,
  isStatusUnseen?: boolean,
  isStatusCheckIn?: boolean,
  mode?: StationMode,
  brindeTagId?: number | null,
}

type ParamsType = {
  limit: number,
  page: number,
  search?: string,
  mode?: StationMode,
  status?: string,
  // eslint-disable-next-line camelcase
  lead_status?: string,
  // eslint-disable-next-line camelcase
  brinde_status?: string,
  // eslint-disable-next-line camelcase
  brinde_tag_id?: number
}

export type Response = {
  list: {
    id: string
    isStatusCheckIn: boolean
    isStatusCheckOut: boolean
    leadCollected: boolean
    giftEligible: number
    giftDone: number
    name: string
    email: string
  }[]
  meta: {
    currentPage: number
    perPage: number
    totalPages: number
  }
}

export async function fetchAttendeeList (
  pagination: PaginationArg,
  filter: FilterArg = {}
): Promise<Response> {
  const mode = filter.mode || 'checkin'
  const params: ParamsType = {
    limit: pagination.limit,
    page: pagination.page,
    mode
  }
  if (filter.search) {
    params.search = filter.search
  }

  // No modo brinde a lista trabalha sobre o CATÁLOGO (tags `gift`): sem filtro,
  // é a visão AGREGADA (progresso elegíveis × retirados). Com brinde_tag_id, a
  // lista/abas/contadores são escopados àquele brinde específico.
  if (mode === 'brinde' && filter.brindeTagId) {
    params.brinde_tag_id = filter.brindeTagId
  }

  // As abas (Aguardando vs concluídos) filtram por status conforme o modo.
  if (mode === 'lead') {
    if (filter.isStatusUnseen) params.lead_status = '0'
    if (filter.isStatusCheckIn) params.lead_status = '1'
  } else if (mode === 'brinde') {
    if (filter.isStatusUnseen) params.brinde_status = '0'
    if (filter.isStatusCheckIn) params.brinde_status = '1'
  } else {
    if (filter.isStatusUnseen) params.status = '0'
    if (filter.isStatusCheckIn) params.status = '1'
  }

  const response = await http.get('/admin/check-in/participants', { params })
  if (response.status !== 200) {
    const exc = { CODID: 'NC93S3NT', error: new Error('NC93S3NT'), response }
    throw exc
  }
  return {
    list: response.data.data.map((item: any) => ({
      id: item.id + '',
      isStatusCheckIn: item.status_check === 1,
      isStatusCheckOut: item.status_check === 2,
      leadCollected: !!item.lead_collected,
      giftEligible: Number(item.gift_eligible || 0),
      giftDone: Number(item.gift_done || 0),
      name: item.name,
      email: item.email
    })),
    meta: {
      currentPage: response.data.meta.pagination.current_page,
      perPage: response.data.meta.pagination.per_page,
      totalPages: response.data.meta.pagination.total_pages
    }
  }
}
